import { render, staticRenderFns } from "./Creates.vue?vue&type=template&id=0f792354&"
import script from "./Creates.vue?vue&type=script&lang=js&"
export * from "./Creates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports